import { Loader2 } from 'lucide-react'

interface LoadingSpinnerProps {
  message?: string
  size?: 'sm' | 'md' | 'lg'
  fullScreen?: boolean
  className?: string
}

export function LoadingSpinner({
  message = 'Loading...',
  size = 'md',
  fullScreen = false,
  className = '',
}: LoadingSpinnerProps) {
  const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-8 w-8',
    lg: 'h-12 w-12',
  }

  const containerClasses = fullScreen
    ? 'fixed inset-0 bg-background/80 backdrop-blur-sm z-50 flex items-center justify-center'
    : 'flex items-center justify-center py-12'

  return (
    <div className={`${containerClasses} ${className}`}>
      <div className="flex flex-col items-center space-y-3">
        <Loader2
          className={`${sizeClasses[size]} animate-spin text-muted-foreground`}
        />
        {message && (
          <p className="text-muted-foreground text-sm font-medium">{message}</p>
        )}
      </div>
    </div>
  )
}

// Specific loaders for common use cases
export function FullPageLoader({
  message = 'Loading...',
}: {
  message?: string
}) {
  return <LoadingSpinner message={message} size="lg" fullScreen />
}

export function InlineLoader({ message }: { message?: string }) {
  return <LoadingSpinner message={message} size="sm" fullScreen={false} />
}

export function CardLoader({ message = 'Loading...' }: { message?: string }) {
  return (
    <div className="w-full rounded-2xl border border-border shadow-sm bg-card">
      <div className="p-6">
        <LoadingSpinner message={message} size="md" />
      </div>
    </div>
  )
}
